export default __webpack_public_path__ + "static/media/Onboarding3.7417926b.gif";